export default (context, inject) => {
    inject("prefersReducedMotion", process.server || window.matchMedia("(prefers-reduced-motion: reduce)").matches);
};
